module.exports = __webpack_public_path__ + "joined-the-club.svg?13605a8b027014f674426a84d1e0fe80";